import React from 'react';
import DynamicContent from '../components/DynamicContent';

function Home() {
  return (
    <div>
      <h1>Welcome to the Dynamic React App</h1>
      <DynamicContent />
    </div>
  );
}

export default Home;
